

/*
ヘッダー
------------------------------------------------------------------*/
$(function () {
  $(window).on('scroll', function () {
    if ('100'< $(this).scrollTop()) {
        $('.header__heading').fadeIn();
        
        $('.headeroverlay').addClass('change-color');
    } else {
        $('.header__heading').fadeOut();
        $('.headeroverlay').removeClass('change-color');
    }
  });
});


/*
モーダル
------------------------------------------------------------------*/
$(function(){
  $(".md-btn").each(function(){
    $(this).on('click',function(e){
      e.preventDefault();
      var target = $(this).data('target');
      var modal = document.getElementById(target);
      $(modal).find('.md-overlay,.md-contents').fadeIn();
    });
  });
  $('.md-close').on('click',function(){
    $('.md-overlay,.md-contents').fadeOut();
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $('.md-overlay').on('click',function(){
    $('.md-overlay,.md-contents').fadeOut();
  });
});

/*
モーダル マイページ
------------------------------------------------------------------*/
  $(".modal-open").modaal({
  overlay_close:true,//モーダル背景クリック時に閉じるか
  before_open:function(){// モーダルが開く前に行う動作
    $('html').css('overflow-y','hidden');/*縦スクロールバーを出さない*/
  },
  after_close:function(){// モーダルが閉じた後に行う動作
    $('html').css('overflow-y','scroll');/*縦スクロールバーを出す*/
  }
  });


